/** @jsx React.DOM */

var React = require("react/addons");
var TerminalsActions = require('editor/actions/TerminalsActions');

var Terminal = React.createClass({displayName: 'Terminal',
  render: function() {
    return (
      React.DOM.div({className: "row"}, 
        React.DOM.div({className: "col-md-12"}, 
          React.DOM.div({ref: "terminal"})
        )
      )
    );
  },

  shouldComponentUpdate: function() {
    return false;
  },

  componentDidMount: function() {
    var terminal = this.props.terminal;

    terminal.terminal.on("data", function(data) {
      TerminalsActions.startUpdateTerminal({
        id: terminal.id,
        data: data
      });
    });

    terminal.terminal.open(this.refs.terminal.getDOMNode());
  }
});


module.exports = Terminal;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/terminals/Terminal.js
 ** module id = 57
 ** module chunks = 0
 **/